/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { AttributeFragmentFragmentGQLType } from '../../attribute/attribute.gql.generated';
import { gql } from '@apollo/client';
import { AttributeFragmentFragmentDocGQLType } from '../../attribute/attribute.gql.generated';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CoreBorrowingBaseInsightsFragmentGQLType = (
  { __typename?: 'CoreBorrowingBaseInsightsGqlData' }
  & Pick<Types.CoreBorrowingBaseInsightsGqlDataGQLType, 'reportingDate' | 'fileVersion' | 'totalReceivableExposure' | 'totalEligibleExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalReceivableBorrowingBaseAmount' | 'effectiveReceivableAdvanceRate' | 'totalEligibleBorrowingBaseAccountCash' | 'totalCollectionsAccountCash' | 'totalPreAdvanceCashContribution' | 'totalCashBorrowingBaseAmount' | 'effectiveCashAdvanceRate' | 'totalBorrowingBaseAmount' | 'effectiveAdvanceRate' | 'totalAssets' | 'commitmentAmount' | 'currentPrincipalBalance' | 'totalFacilityUtilization'>
);

export type GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType = Types.Exact<{
  creditFacilityParams: Types.CreditFacilityInsightsParamInputGQLType;
}>;


export type GetDailyCoreBorrowingBaseInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyCoreBorrowingBaseInsights: Array<(
    { __typename?: 'CoreBorrowingBaseInsightsGqlData' }
    & CoreBorrowingBaseInsightsFragmentGQLType
  )> }
);

export type GetDailyEligibilityInsightsQueryVariablesGQLType = Types.Exact<{
  creditFacilityParams: Types.CreditFacilityInsightsParamInputGQLType;
}>;


export type GetDailyEligibilityInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyEligibilityInsights: Array<(
    { __typename?: 'EligibilityAggregateInsightsGqlData' }
    & Pick<Types.EligibilityAggregateInsightsGqlDataGQLType, 'reportingDate' | 'totalEligibleExposure' | 'totalNetEligibilityKickout' | 'totalGrossEligibilityKickout'>
    & { eligibilityPropertiesData: Array<(
      { __typename?: 'EligibilityPropertyInsightsGqlData' }
      & Pick<Types.EligibilityPropertyInsightsGqlDataGQLType, 'propertyKey' | 'totalEligibilityKickout'>
    )> }
  )> }
);

export type GetDailyConcentrationInsightsQueryVariablesGQLType = Types.Exact<{
  creditFacilityParams: Types.CreditFacilityInsightsParamInputGQLType;
}>;


export type GetDailyConcentrationInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyConcentrationInsights: Array<(
    { __typename?: 'ConcentrationLimitAggregateInsightsGqlData' }
    & Pick<Types.ConcentrationLimitAggregateInsightsGqlDataGQLType, 'reportingDate' | 'totalConcentrationLimitKickout'>
    & { concentrationLimitsData: Array<(
      { __typename?: 'ConcentrationLimitInsightsGqlData' }
      & Pick<Types.ConcentrationLimitInsightsGqlDataGQLType, 'reportingDate' | 'propertyKey' | 'valueType' | 'concentrationAmount' | 'concentrationLimit' | 'concentration' | 'totalConcentrationLimitKickout'>
    )> }
  )> }
);

export type GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType = Types.Exact<{
  creditFacilityParams: Types.CreditFacilityInsightsParamInputGQLType;
}>;


export type GetDailyPreadvanceCollectionsCashBalanceQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyCoreBorrowingBaseInsights: Array<(
    { __typename?: 'CoreBorrowingBaseInsightsGqlData' }
    & Pick<Types.CoreBorrowingBaseInsightsGqlDataGQLType, 'reportingDate' | 'totalCollectionsAccountCash'>
  )> }
);

export type GetDailyTotalRiskInsightsQueryVariablesGQLType = Types.Exact<{
  organizationParams: Types.OrganizationInsightsParamInputGQLType;
}>;


export type GetDailyTotalRiskInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { riskData: (
    { __typename?: 'TotalRiskInsightsOutputData' }
    & { borrowingBaseRisk: Array<(
      { __typename?: 'AggregateBorrowingRiskInsightsGqlData' }
      & Pick<Types.AggregateBorrowingRiskInsightsGqlDataGQLType, 'reportingDate' | 'totalPerformingExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalCollectionsAccountCash' | 'currentPrincipalBalance' | 'collateralCovenantLtv' | 'netOutstandingLtv' | 'performingLtv'>
      & { creditFacilityData: Array<(
        { __typename?: 'CreditFacilityBorrowingRiskInsightsGqlData' }
        & Pick<Types.CreditFacilityBorrowingRiskInsightsGqlDataGQLType, 'creditFacilityId' | 'creditFacilitySlug' | 'reportingDate' | 'totalPerformingExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalCollectionsAccountCash' | 'currentPrincipalBalance' | 'collateralCovenantLtv' | 'netOutstandingLtv' | 'performingLtv'>
      )> }
    )>, receivableRisk: Array<(
      { __typename?: 'AggregateReceivableRiskInsightsGqlData' }
      & Pick<Types.AggregateReceivableRiskInsightsGqlDataGQLType, 'reportingDate' | 'totalExposure' | 'totalNormalizedIsChargedOffExposure' | 'totalNormalizedIsDelinquentExposure' | 'chargedOffPercentageOfTotalExposure' | 'delinquentPercentageOfTotalExposure'>
      & { creditFacilityData: Array<(
        { __typename?: 'CreditFacilityReceivableRiskInsightsGqlData' }
        & Pick<Types.CreditFacilityReceivableRiskInsightsGqlDataGQLType, 'reportingDate' | 'creditFacilityId' | 'creditFacilitySlug' | 'totalExposure' | 'totalNormalizedIsChargedOffExposure' | 'totalNormalizedIsDelinquentExposure' | 'chargedOffPercentageOfTotalExposure' | 'delinquentPercentageOfTotalExposure'>
      )> }
    )> }
  ) }
);

export type GetDailyReceivableExposureInsightsQueryVariablesGQLType = Types.Exact<{
  organizationParams: Types.OrganizationInsightsParamInputGQLType;
}>;


export type GetDailyReceivableExposureInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyReceivableExposureInsights: Array<(
    { __typename?: 'AggregateReceivableExposureInsightsGqlData' }
    & Pick<Types.AggregateReceivableExposureInsightsGqlDataGQLType, 'reportingDate' | 'totalExposure' | 'totalPerformingExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalReceivableBorrowingBase'>
    & { creditFacilityData: Array<(
      { __typename?: 'CreditFacilityReceivableExposureInsightsGqlData' }
      & Pick<Types.CreditFacilityReceivableExposureInsightsGqlDataGQLType, 'reportingDate' | 'creditFacilityId' | 'creditFacilitySlug' | 'totalExposure' | 'totalPerformingExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalReceivableBorrowingBase'>
    )> }
  )> }
);

export type GetDailyPrincipalInsightsQueryVariablesGQLType = Types.Exact<{
  organizationParams: Types.OrganizationInsightsParamInputGQLType;
}>;


export type GetDailyPrincipalInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyPrincipalInsights: Array<(
    { __typename?: 'AggregatePrincipalInsightsGqlData' }
    & Pick<Types.AggregatePrincipalInsightsGqlDataGQLType, 'reportingDate' | 'currentPrincipalBalance' | 'commitmentAmount' | 'totalFacilityUtilization'>
    & { creditFacilityData: Array<(
      { __typename?: 'CreditFacilityPrincipalInsightsGqlData' }
      & Pick<Types.CreditFacilityPrincipalInsightsGqlDataGQLType, 'reportingDate' | 'creditFacilityId' | 'creditFacilitySlug' | 'currentPrincipalBalance' | 'commitmentAmount' | 'totalFacilityUtilization'>
    )> }
  )> }
);

export type GetProfitOverviewInsightsQueryVariablesGQLType = Types.Exact<{
  creditFacilityParams: Types.CreditFacilityInsightsParamInputGQLType;
}>;


export type GetProfitOverviewInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getProfitOverviewInsights: Array<(
    { __typename?: 'CreditFacilityProfitOverviewInsightsGqlData' }
    & Pick<Types.CreditFacilityProfitOverviewInsightsGqlDataGQLType, 'creditFacilityId' | 'creditFacilitySlug' | 'reportingDate' | 'totalExposure' | 'totalNormalizedIsChargedOffExposure' | 'totalNormalizedIsDelinquentExposure' | 'totalExposureDaysPastDue0' | 'totalExposureDaysPastDue1to30' | 'totalExposureDaysPastDue31to60' | 'totalExposureDaysPastDue61to90' | 'totalExposureDaysPastDue91to120' | 'totalExposureDaysPastDue121plus' | 'chargedOffPercentageOfTotalExposure' | 'delinquentPercentageOfTotalExposure' | 'percentExposureDaysPastDue0' | 'percentExposureDaysPastDue1to30' | 'percentExposureDaysPastDue31to60' | 'percentExposureDaysPastDue61to90' | 'percentExposureDaysPastDue91to120' | 'percentExposureDaysPastDue121plus'>
  )> }
);

export type GetProfitVintageInsightsQueryVariablesGQLType = Types.Exact<{
  creditFacilityParams: Types.CreditFacilityInsightsParamInputGQLType;
}>;


export type GetProfitVintageInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getProfitVintageInsights: (
    { __typename?: 'CreditFacilityProfitFullVintageInsightsGqlData' }
    & { profitVintageInputData: Array<(
      { __typename?: 'CreditFacilityProfitVintageInputInsightsGqlData' }
      & Pick<Types.CreditFacilityProfitVintageInputInsightsGqlDataGQLType, 'cohortBaseDate' | 'cohortSeriesDate' | 'totalVintageCalcValue' | 'totalNormalizedIsChargedOffVintageCalcValue' | 'totalNormalizedIsDelinquentVintageCalcValue'>
    )> }
  ) }
);

export type GetRepaymentVintageInsightsQueryVariablesGQLType = Types.Exact<{
  creditFacilityParams: Types.CreditFacilityRepaymentInsightsParamInputGQLType;
}>;


export type GetRepaymentVintageInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getRepaymentVintageInsights: (
    { __typename?: 'CreditFacilityRepaymentVintageInsightsGqlData' }
    & { repaymentVintageInputData: Array<(
      { __typename?: 'CreditFacilityRepaymentVintageInputInsightsGqlData' }
      & Pick<Types.CreditFacilityRepaymentVintageInputInsightsGqlDataGQLType, 'cohortBaseDate' | 'cohortSeriesDate' | 'cumulativeRepayments'>
    )>, receivableOriginationSummaryInfo: Array<(
      { __typename?: 'CreditFacilityReceivableOriginationSummaryInfo' }
      & Pick<Types.CreditFacilityReceivableOriginationSummaryInfoGQLType, 'originationDate' | 'originatedReceivablesCount' | 'totalInitialBalanceOfOriginatedReceivables'>
    )> }
  ) }
);

export type GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetCustomerProvidedVariablesAndValuesQueryGQLType = (
  { __typename?: 'Query' }
  & { attributes: Array<(
    { __typename?: 'Attribute' }
    & AttributeFragmentFragmentGQLType
  )> }
);

export type CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType = Types.Exact<{
  attributeId: Types.Scalars['UUID'];
  creditFacilityId: Types.Scalars['UUID'];
  effectiveFromReportingDate: Types.Scalars['FullDateStr'];
  value: Types.AttributeValueInputGQLType;
}>;


export type CreateOrUpdateCustomerProvidedValueMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createOrUpdateCustomerProvidedValue: (
    { __typename?: 'ResponseWithString' }
    & Pick<Types.ResponseWithStringGQLType, 'response'>
  ) }
);

export const CoreBorrowingBaseInsightsFragmentDocGQLType = gql`
    fragment CoreBorrowingBaseInsights on CoreBorrowingBaseInsightsGqlData {
  reportingDate
  fileVersion
  totalReceivableExposure
  totalEligibleExposure
  totalEligibleExposureLessConcentrationKickouts
  totalReceivableBorrowingBaseAmount
  effectiveReceivableAdvanceRate
  totalEligibleBorrowingBaseAccountCash
  totalCollectionsAccountCash
  totalPreAdvanceCashContribution
  totalCashBorrowingBaseAmount
  effectiveCashAdvanceRate
  totalBorrowingBaseAmount
  effectiveAdvanceRate
  totalAssets
  commitmentAmount
  currentPrincipalBalance
  totalFacilityUtilization
}
    `;
export const GetDailyCoreBorrowingBaseInsightsDocumentGQLType = gql`
    query GetDailyCoreBorrowingBaseInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getDailyCoreBorrowingBaseInsights(creditFacilityParams: $creditFacilityParams) {
    ...CoreBorrowingBaseInsights
  }
}
    ${CoreBorrowingBaseInsightsFragmentDocGQLType}`;

/**
 * __useGetDailyCoreBorrowingBaseInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyCoreBorrowingBaseInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyCoreBorrowingBaseInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyCoreBorrowingBaseInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetDailyCoreBorrowingBaseInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>(GetDailyCoreBorrowingBaseInsightsDocumentGQLType, options);
      }
export function useGetDailyCoreBorrowingBaseInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>(GetDailyCoreBorrowingBaseInsightsDocumentGQLType, options);
        }
export type GetDailyCoreBorrowingBaseInsightsQueryHookResult = ReturnType<typeof useGetDailyCoreBorrowingBaseInsightsQuery>;
export type GetDailyCoreBorrowingBaseInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyCoreBorrowingBaseInsightsLazyQueryGQLType>;
export type GetDailyCoreBorrowingBaseInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>;
export const GetDailyEligibilityInsightsDocumentGQLType = gql`
    query GetDailyEligibilityInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getDailyEligibilityInsights(creditFacilityParams: $creditFacilityParams) {
    reportingDate
    totalEligibleExposure
    totalNetEligibilityKickout
    totalGrossEligibilityKickout
    eligibilityPropertiesData {
      propertyKey
      totalEligibilityKickout
    }
  }
}
    `;

/**
 * __useGetDailyEligibilityInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyEligibilityInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyEligibilityInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyEligibilityInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetDailyEligibilityInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>(GetDailyEligibilityInsightsDocumentGQLType, options);
      }
export function useGetDailyEligibilityInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>(GetDailyEligibilityInsightsDocumentGQLType, options);
        }
export type GetDailyEligibilityInsightsQueryHookResult = ReturnType<typeof useGetDailyEligibilityInsightsQuery>;
export type GetDailyEligibilityInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyEligibilityInsightsLazyQueryGQLType>;
export type GetDailyEligibilityInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>;
export const GetDailyConcentrationInsightsDocumentGQLType = gql`
    query GetDailyConcentrationInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getDailyConcentrationInsights(creditFacilityParams: $creditFacilityParams) {
    reportingDate
    totalConcentrationLimitKickout
    concentrationLimitsData {
      reportingDate
      propertyKey
      valueType
      concentrationAmount
      concentrationLimit
      concentration
      totalConcentrationLimitKickout
    }
  }
}
    `;

/**
 * __useGetDailyConcentrationInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyConcentrationInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyConcentrationInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyConcentrationInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetDailyConcentrationInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>(GetDailyConcentrationInsightsDocumentGQLType, options);
      }
export function useGetDailyConcentrationInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>(GetDailyConcentrationInsightsDocumentGQLType, options);
        }
export type GetDailyConcentrationInsightsQueryHookResult = ReturnType<typeof useGetDailyConcentrationInsightsQuery>;
export type GetDailyConcentrationInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyConcentrationInsightsLazyQueryGQLType>;
export type GetDailyConcentrationInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>;
export const GetDailyPreadvanceCollectionsCashBalanceDocumentGQLType = gql`
    query GetDailyPreadvanceCollectionsCashBalance($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getDailyCoreBorrowingBaseInsights(creditFacilityParams: $creditFacilityParams) {
    reportingDate
    totalCollectionsAccountCash
  }
}
    `;

/**
 * __useGetDailyPreadvanceCollectionsCashBalanceQuery__
 *
 * To run a query within a React component, call `useGetDailyPreadvanceCollectionsCashBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyPreadvanceCollectionsCashBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyPreadvanceCollectionsCashBalanceQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetDailyPreadvanceCollectionsCashBalanceQuery(baseOptions: Apollo.QueryHookOptions<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>(GetDailyPreadvanceCollectionsCashBalanceDocumentGQLType, options);
      }
export function useGetDailyPreadvanceCollectionsCashBalanceLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>(GetDailyPreadvanceCollectionsCashBalanceDocumentGQLType, options);
        }
export type GetDailyPreadvanceCollectionsCashBalanceQueryHookResult = ReturnType<typeof useGetDailyPreadvanceCollectionsCashBalanceQuery>;
export type GetDailyPreadvanceCollectionsCashBalanceLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyPreadvanceCollectionsCashBalanceLazyQueryGQLType>;
export type GetDailyPreadvanceCollectionsCashBalanceQueryResultGQLType = Apollo.QueryResult<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>;
export const GetDailyTotalRiskInsightsDocumentGQLType = gql`
    query GetDailyTotalRiskInsights($organizationParams: OrganizationInsightsParamInput!) {
  riskData: getDailyTotalRiskInsights(organizationParams: $organizationParams) {
    borrowingBaseRisk {
      reportingDate
      totalPerformingExposure
      totalEligibleExposureLessConcentrationKickouts
      totalCollectionsAccountCash
      currentPrincipalBalance
      collateralCovenantLtv
      netOutstandingLtv
      performingLtv
      creditFacilityData {
        creditFacilityId
        creditFacilitySlug
        reportingDate
        totalPerformingExposure
        totalEligibleExposureLessConcentrationKickouts
        totalCollectionsAccountCash
        currentPrincipalBalance
        collateralCovenantLtv
        netOutstandingLtv
        performingLtv
      }
    }
    receivableRisk {
      reportingDate
      totalExposure
      totalNormalizedIsChargedOffExposure
      totalNormalizedIsDelinquentExposure
      chargedOffPercentageOfTotalExposure
      delinquentPercentageOfTotalExposure
      creditFacilityData {
        reportingDate
        creditFacilityId
        creditFacilitySlug
        totalExposure
        totalNormalizedIsChargedOffExposure
        totalNormalizedIsDelinquentExposure
        chargedOffPercentageOfTotalExposure
        delinquentPercentageOfTotalExposure
      }
    }
  }
}
    `;

/**
 * __useGetDailyTotalRiskInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyTotalRiskInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyTotalRiskInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyTotalRiskInsightsQuery({
 *   variables: {
 *      organizationParams: // value for 'organizationParams'
 *   },
 * });
 */
export function useGetDailyTotalRiskInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>(GetDailyTotalRiskInsightsDocumentGQLType, options);
      }
export function useGetDailyTotalRiskInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>(GetDailyTotalRiskInsightsDocumentGQLType, options);
        }
export type GetDailyTotalRiskInsightsQueryHookResult = ReturnType<typeof useGetDailyTotalRiskInsightsQuery>;
export type GetDailyTotalRiskInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyTotalRiskInsightsLazyQueryGQLType>;
export type GetDailyTotalRiskInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>;
export const GetDailyReceivableExposureInsightsDocumentGQLType = gql`
    query GetDailyReceivableExposureInsights($organizationParams: OrganizationInsightsParamInput!) {
  getDailyReceivableExposureInsights(organizationParams: $organizationParams) {
    reportingDate
    totalExposure
    totalPerformingExposure
    totalEligibleExposureLessConcentrationKickouts
    totalReceivableBorrowingBase
    creditFacilityData {
      reportingDate
      creditFacilityId
      creditFacilitySlug
      totalExposure
      totalPerformingExposure
      totalEligibleExposureLessConcentrationKickouts
      totalReceivableBorrowingBase
    }
  }
}
    `;

/**
 * __useGetDailyReceivableExposureInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyReceivableExposureInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReceivableExposureInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReceivableExposureInsightsQuery({
 *   variables: {
 *      organizationParams: // value for 'organizationParams'
 *   },
 * });
 */
export function useGetDailyReceivableExposureInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>(GetDailyReceivableExposureInsightsDocumentGQLType, options);
      }
export function useGetDailyReceivableExposureInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>(GetDailyReceivableExposureInsightsDocumentGQLType, options);
        }
export type GetDailyReceivableExposureInsightsQueryHookResult = ReturnType<typeof useGetDailyReceivableExposureInsightsQuery>;
export type GetDailyReceivableExposureInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyReceivableExposureInsightsLazyQueryGQLType>;
export type GetDailyReceivableExposureInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>;
export const GetDailyPrincipalInsightsDocumentGQLType = gql`
    query GetDailyPrincipalInsights($organizationParams: OrganizationInsightsParamInput!) {
  getDailyPrincipalInsights(organizationParams: $organizationParams) {
    reportingDate
    currentPrincipalBalance
    commitmentAmount
    totalFacilityUtilization
    creditFacilityData {
      reportingDate
      creditFacilityId
      creditFacilitySlug
      currentPrincipalBalance
      commitmentAmount
      totalFacilityUtilization
    }
  }
}
    `;

/**
 * __useGetDailyPrincipalInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyPrincipalInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyPrincipalInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyPrincipalInsightsQuery({
 *   variables: {
 *      organizationParams: // value for 'organizationParams'
 *   },
 * });
 */
export function useGetDailyPrincipalInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>(GetDailyPrincipalInsightsDocumentGQLType, options);
      }
export function useGetDailyPrincipalInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>(GetDailyPrincipalInsightsDocumentGQLType, options);
        }
export type GetDailyPrincipalInsightsQueryHookResult = ReturnType<typeof useGetDailyPrincipalInsightsQuery>;
export type GetDailyPrincipalInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyPrincipalInsightsLazyQueryGQLType>;
export type GetDailyPrincipalInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>;
export const GetProfitOverviewInsightsDocumentGQLType = gql`
    query GetProfitOverviewInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getProfitOverviewInsights(creditFacilityParams: $creditFacilityParams) {
    creditFacilityId
    creditFacilitySlug
    reportingDate
    totalExposure
    totalNormalizedIsChargedOffExposure
    totalNormalizedIsDelinquentExposure
    totalExposureDaysPastDue0
    totalExposureDaysPastDue1to30
    totalExposureDaysPastDue31to60
    totalExposureDaysPastDue61to90
    totalExposureDaysPastDue91to120
    totalExposureDaysPastDue121plus
    chargedOffPercentageOfTotalExposure
    delinquentPercentageOfTotalExposure
    percentExposureDaysPastDue0
    percentExposureDaysPastDue1to30
    percentExposureDaysPastDue31to60
    percentExposureDaysPastDue61to90
    percentExposureDaysPastDue91to120
    percentExposureDaysPastDue121plus
  }
}
    `;

/**
 * __useGetProfitOverviewInsightsQuery__
 *
 * To run a query within a React component, call `useGetProfitOverviewInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfitOverviewInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfitOverviewInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetProfitOverviewInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>(GetProfitOverviewInsightsDocumentGQLType, options);
      }
export function useGetProfitOverviewInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>(GetProfitOverviewInsightsDocumentGQLType, options);
        }
export type GetProfitOverviewInsightsQueryHookResult = ReturnType<typeof useGetProfitOverviewInsightsQuery>;
export type GetProfitOverviewInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetProfitOverviewInsightsLazyQueryGQLType>;
export type GetProfitOverviewInsightsQueryResultGQLType = Apollo.QueryResult<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>;
export const GetProfitVintageInsightsDocumentGQLType = gql`
    query GetProfitVintageInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getProfitVintageInsights(creditFacilityParams: $creditFacilityParams) {
    profitVintageInputData {
      cohortBaseDate
      cohortSeriesDate
      totalVintageCalcValue
      totalNormalizedIsChargedOffVintageCalcValue
      totalNormalizedIsDelinquentVintageCalcValue
    }
  }
}
    `;

/**
 * __useGetProfitVintageInsightsQuery__
 *
 * To run a query within a React component, call `useGetProfitVintageInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfitVintageInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfitVintageInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetProfitVintageInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>(GetProfitVintageInsightsDocumentGQLType, options);
      }
export function useGetProfitVintageInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>(GetProfitVintageInsightsDocumentGQLType, options);
        }
export type GetProfitVintageInsightsQueryHookResult = ReturnType<typeof useGetProfitVintageInsightsQuery>;
export type GetProfitVintageInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetProfitVintageInsightsLazyQueryGQLType>;
export type GetProfitVintageInsightsQueryResultGQLType = Apollo.QueryResult<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>;
export const GetRepaymentVintageInsightsDocumentGQLType = gql`
    query GetRepaymentVintageInsights($creditFacilityParams: CreditFacilityRepaymentInsightsParamInput!) {
  getRepaymentVintageInsights(creditFacilityParams: $creditFacilityParams) {
    repaymentVintageInputData {
      cohortBaseDate
      cohortSeriesDate
      cumulativeRepayments
    }
    receivableOriginationSummaryInfo {
      originationDate
      originatedReceivablesCount
      totalInitialBalanceOfOriginatedReceivables
    }
  }
}
    `;

/**
 * __useGetRepaymentVintageInsightsQuery__
 *
 * To run a query within a React component, call `useGetRepaymentVintageInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRepaymentVintageInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepaymentVintageInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetRepaymentVintageInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>(GetRepaymentVintageInsightsDocumentGQLType, options);
      }
export function useGetRepaymentVintageInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>(GetRepaymentVintageInsightsDocumentGQLType, options);
        }
export type GetRepaymentVintageInsightsQueryHookResult = ReturnType<typeof useGetRepaymentVintageInsightsQuery>;
export type GetRepaymentVintageInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRepaymentVintageInsightsLazyQueryGQLType>;
export type GetRepaymentVintageInsightsQueryResultGQLType = Apollo.QueryResult<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>;
export const GetCustomerProvidedVariablesAndValuesDocumentGQLType = gql`
    query GetCustomerProvidedVariablesAndValues($creditFacilityId: UUID!) {
  attributes: getCustomerProvidedVariablesAndValues(
    creditFacilityId: $creditFacilityId
  ) {
    ...AttributeFragment
  }
}
    ${AttributeFragmentFragmentDocGQLType}`;

/**
 * __useGetCustomerProvidedVariablesAndValuesQuery__
 *
 * To run a query within a React component, call `useGetCustomerProvidedVariablesAndValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerProvidedVariablesAndValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerProvidedVariablesAndValuesQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCustomerProvidedVariablesAndValuesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>(GetCustomerProvidedVariablesAndValuesDocumentGQLType, options);
      }
export function useGetCustomerProvidedVariablesAndValuesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>(GetCustomerProvidedVariablesAndValuesDocumentGQLType, options);
        }
export type GetCustomerProvidedVariablesAndValuesQueryHookResult = ReturnType<typeof useGetCustomerProvidedVariablesAndValuesQuery>;
export type GetCustomerProvidedVariablesAndValuesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCustomerProvidedVariablesAndValuesLazyQueryGQLType>;
export type GetCustomerProvidedVariablesAndValuesQueryResultGQLType = Apollo.QueryResult<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>;
export const CreateOrUpdateCustomerProvidedValueDocumentGQLType = gql`
    mutation CreateOrUpdateCustomerProvidedValue($attributeId: UUID!, $creditFacilityId: UUID!, $effectiveFromReportingDate: FullDateStr!, $value: AttributeValueInput!) {
  createOrUpdateCustomerProvidedValue(
    attributeId: $attributeId
    creditFacilityId: $creditFacilityId
    effectiveFromReportingDate: $effectiveFromReportingDate
    value: $value
  ) {
    response
  }
}
    `;
export type CreateOrUpdateCustomerProvidedValueMutationFnGQLType = Apollo.MutationFunction<CreateOrUpdateCustomerProvidedValueMutationGQLType, CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType>;

/**
 * __useCreateOrUpdateCustomerProvidedValueMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCustomerProvidedValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCustomerProvidedValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCustomerProvidedValueMutation, { data, loading, error }] = useCreateOrUpdateCustomerProvidedValueMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      effectiveFromReportingDate: // value for 'effectiveFromReportingDate'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateOrUpdateCustomerProvidedValueMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCustomerProvidedValueMutationGQLType, CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCustomerProvidedValueMutationGQLType, CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType>(CreateOrUpdateCustomerProvidedValueDocumentGQLType, options);
      }
export type CreateOrUpdateCustomerProvidedValueMutationHookResult = ReturnType<typeof useCreateOrUpdateCustomerProvidedValueMutation>;
export type CreateOrUpdateCustomerProvidedValueMutationResultGQLType = Apollo.MutationResult<CreateOrUpdateCustomerProvidedValueMutationGQLType>;
export type CreateOrUpdateCustomerProvidedValueMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateOrUpdateCustomerProvidedValueMutationGQLType, CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType>;